const state = () => ({
  customAnalytics: null,

  associationId: null,
  baseReportName: null,
  subId: null,

  publisher: null,
  publishers: [],

  team: null,
  teams: {},

  currentRecord: {},

  publisherViewStatus: null,

  isLoadingPublisher: false,
  didLoadPublisherFail: false,

  isLoadingTeams: false,
  didLoadTeamsFail: false,
})

export default state
